
import { Route, Navigate } from 'react-router-dom';
import { AuthGuard } from '../components/AuthGuard';
import { PremiumRoute } from '../components/auth/PremiumRoute';
import { AdminRoute } from '../components/auth/AdminRoute';
import { MainLayout } from '../layouts/MainLayout';
import Techniques from '../pages/Techniques';
import TechniqueDetail from '../pages/TechniqueDetail';
import MyTechniques from '../pages/MyTechniques';
import GamePlanner2 from '../pages/GamePlanner2';
import TrainingJournalNew from '../features/training-journal/TrainingJournalNew';
import Profile from '../pages/Profile';
import Affiliates from '../pages/Affiliates';
import Subscription from '../pages/Subscription';
import RoadmapAdmin from '../pages/RoadmapAdmin';
import Roadmap from '../pages/Roadmap';

import BlogCreateEdit from '../pages/admin/BlogCreateEdit';
// IAP Test imports - Temporarily disabled until App Store Connect issues resolved
// import IAPConfigTest from '../pages/debug/IAPConfigTest';
// import IAPStepTest from '../pages/debug/IAPStepTest';
import { SubscriptionDiagnosticsPanel } from '../components/debug/SubscriptionDiagnosticsPanel';

import { TrainingJournalProvider } from '../features/training-journal/context/TrainingJournalContext';

export const AuthenticatedRoutes = [
  <Route key="auth-routes" element={<AuthGuard />}>
    <Route path="/dashboard" element={<Navigate to="/journal" replace />} />
    
    <Route path="/techniques" element={
      <MainLayout>
        <Techniques />
      </MainLayout>
    } />
    <Route path="/techniques/:slug" element={
      <MainLayout>
        <TechniqueDetail />
      </MainLayout>
    } />
    
    <Route element={<PremiumRoute />}>
      <Route path="/my-techniques" element={
        <MainLayout>
          <MyTechniques />
        </MainLayout>
      } />
      <Route path="/game-planner2" element={
        <MainLayout>
          <GamePlanner2 />
        </MainLayout>
      } />
    </Route>
    
    <Route path="/journal" element={
      <MainLayout>
        <TrainingJournalProvider>
          <TrainingJournalNew />
        </TrainingJournalProvider>
      </MainLayout>
    } />
    <Route path="/profile" element={
      <MainLayout>
        <Profile />
      </MainLayout>
    } />
    <Route path="/affiliates" element={
      <MainLayout>
        <Affiliates />
      </MainLayout>
    } />
    <Route path="/subscription" element={
      <MainLayout>
        <Subscription />
      </MainLayout>
    } />
    <Route path="/roadmap" element={
      <MainLayout>
        <Roadmap />
      </MainLayout>
    } />

    {/* Debug Routes - Development Only */}
    <Route path="/debug/subscription" element={
      <MainLayout>
        <SubscriptionDiagnosticsPanel />
      </MainLayout>
    } />

    {/* IAP Test Routes - Temporarily disabled until App Store Connect issues resolved */}
    {/*
    <Route path="/debug/iap-config" element={
      <MainLayout>
        <IAPConfigTest />
      </MainLayout>
    } />
    <Route path="/debug/iap-step-test" element={
      <MainLayout>
        <IAPStepTest />
      </MainLayout>
    } />
    */}

    <Route element={<AdminRoute />}>
      <Route path="/roadmap-admin" element={
        <MainLayout>
          <RoadmapAdmin />
        </MainLayout>
      } />
      <Route path="/blog/admin/create" element={
        <MainLayout>
          <BlogCreateEdit />
        </MainLayout>
      } />
      <Route path="/blog/admin/edit/:id" element={
        <MainLayout>
          <BlogCreateEdit />
        </MainLayout>
      } />
    </Route>
  </Route>
];
